<div class="classif-header row align-items-start justify-content-between">
    <div class="col-auto">
        <app-back-button></app-back-button>
    </div>
    <div class="col-12 col-lg-auto col-title mx-auto mx-lg-0">
        <h5>{{ registers?.list?.nome_ranking }}</h5>
        <p class="paragraph-2">{{ registers?.list?.nome_categoria }}</p>
    </div>
    <div class="col-auto">
        <app-shared-filter [filter]="filter" (onChange)="onFilterChange($event)"></app-shared-filter>
    </div>
</div>

<!-- Mostrar mensagem -->
<app-no-results *ngIf="statusCode > 0 || (statusCode > -1 && !classif?.length)"></app-no-results>

<div class="ranking-container" [nbSpinner]="loading" style="min-height: 200px">
    <div class="ranking-th-row" *ngIf="columns?.length && window.innerWidth >= 1200 && classif?.length">
        <div class="ranking-th-cell">
            <span>Pos.</span>
        </div>
        <div class="ranking-th-cell">
            <span>Atleta</span>
        </div>
        <div class="ranking-th-cell th-cell-wtn">
            <div class="ranking-th-cell__svg">
                <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.3177 21.6203C10.3464 20.2885 10.7377 15.7267 9.59762 8.06975C8.83013 2.93283 7.14582 1.76616 6.26849 1.55365C5.74295 1.40647 5.14849 1.44308 4.59998 1.70873C3.44623 2.26514 2.8891 3.59262 3.42541 4.68821C6.13423 10.2114 7.41721 17.3636 8.40223 23.7749C8.51495 24.5137 8.70377 25.5755 8.84593 26.8025C8.91413 27.3912 9.24008 27.659 9.62131 27.6303C10.0018 27.6015 10.2754 27.2591 10.2459 26.763C10.1942 25.8727 10.2861 22.9528 10.3177 21.6203Z"
                        fill="#E53E51"
                    />
                    <path
                        d="M19.7867 15.7504C18.6545 15.7001 14.7841 15.288 8.25434 16.174C3.87413 16.767 2.85464 18.2467 2.65721 19.0192C2.52367 19.4844 2.54449 20.01 2.76275 20.5039C3.21721 21.5392 4.33649 22.0547 5.277 21.5966C10.2222 19.1843 16.6522 18.2022 22.2938 17.4038C22.6851 17.3478 23.584 17.2243 24.3615 17.1324C24.6688 17.0958 24.9079 16.8165 24.8899 16.4784C24.8713 16.1395 24.6085 15.9026 24.2983 15.9026C23.3262 15.9004 20.9197 15.8006 19.7867 15.7504Z"
                        fill="#003A70"
                    />
                    <path
                        d="M17.167 3.35067C17.9732 5.69119 19.3237 9.47837 20.5198 13.6561C20.9979 15.3296 21.3081 17.0039 21.6362 18.7801C22.5896 23.9379 21.4208 25.554 20.6239 26.0529C20.1543 26.3717 19.5549 26.534 18.9274 26.4686C17.6078 26.3322 16.7671 25.162 16.8618 23.5681C16.9379 22.2356 17.251 19.4873 17.1562 17.5086C16.948 13.1701 15.9393 6.60657 15.3771 3.34278C15.2823 2.79067 14.9463 1.09057 14.9463 1.09057C14.8602 0.735905 15.1043 0.368315 15.4898 0.265649C15.8761 0.162982 16.2365 0.344623 16.3471 0.722982C16.5983 1.58452 16.93 2.66216 17.167 3.35067Z"
                        fill="#E53E51"
                    />
                    <path
                        d="M1.17249 10.0585C0.79413 10.1662 0.659874 10.4792 0.728797 10.7656C0.797002 11.0528 1.10213 11.223 1.41157 11.1462C1.41157 11.1462 1.76623 11.0629 2.33126 10.9602C3.44049 10.7578 4.52818 10.5582 5.60798 10.3665C5.45003 9.84883 5.28777 9.34196 5.11403 8.83724C3.88131 9.24647 1.83228 9.8718 1.17249 10.0585ZM16.9774 5.41837C13.8041 5.94678 11.3128 6.62739 9.45475 7.23478C9.505 7.4997 9.54951 7.77826 9.59403 8.0676C9.67803 8.62401 9.75198 9.16032 9.81731 9.68585C13.1385 9.2156 16.4813 8.93919 20.1256 9.10503C21.9255 9.18688 23.4282 8.50339 23.4282 6.98493C23.4282 5.13765 21.2456 4.71191 16.9774 5.41837Z"
                        fill="#003A70"
                    />
                </svg>
            </div>
            <span>WTN</span>
            <button
                nbButton
                ghost
                size="tiny"
                [nbTooltip]="classif[0].wtn.single ? classif[0].wtn.single?.title : classif[0].wtn.double?.title"
                *ngIf="classif?.length"
            >
                <nb-icon icon="alert-circle-outline"></nb-icon>
            </button>
        </div>
        <div class="ranking-th-cell" *ngFor="let column of columns; let index = index">
            <span>{{ column }}</span>
        </div>
    </div>
    <div class="ranking-body">
        <a
            class="ranking-classif"
            *ngFor="let player of classif | slice : (page - 1) * perPage : (page - 1) * perPage + perPage"
            [routerLink]="['../../ranking-2', rankingId, 'player-points', player.player]"
            [queryParams]="{ category: registers?.list.category, ratingDate: registers?.list.rating_date }"
        >
            <div class="ranking-player-classif">
                <span>{{ player.posicao }}º</span>
            </div>
            <div class="ranking-player d-flex align-items-center">
                <div class="ranking-move">
                    <fa-icon
                        [style.color]="getColorByMove(player.posicoes_movtos)"
                        [icon]="getIconByMove(player.posicoes_movtos)"
                    ></fa-icon>
                    <span>{{ player.posicoes_movtos }}</span>
                </div>
                <div class="ranking-info-1">
                    <div class="ranking-image">
                        <img src="{{ player.url_avatar }}" width="60px" />
                    </div>
                    <div>
                        <span class="d-block player-name"
                            ><strong>{{ player.nome }}</strong></span
                        >
                        <span class="d-block player-location">{{ player.cidade }} / {{ player.uf }} </span>
                        <span class="player-age" *ngIf="player.idade"
                            >{{ player.idade }} {{ "GENERAL.AGE" | translate }}</span
                        >
                    </div>
                </div>
            </div>

            <!-- DESKTOP -->
            <div class="ranking-info d-flex align-items-center" *ngIf="window.innerWidth >= 1200">
                <div class="ranking-info-column flex-row align-items-center">
                    <span></span>
                    <span>{{ player.wtn.single ? player.wtn.single?.format : player.wtn.double?.format }}</span>
                </div>

                <ng-container *ngFor="let column of columns; let index = index">
                    <div [class.ranking-info-column]="column" *ngIf="player.rows[index + 1]">
                        <span>{{ player.rows[index + 1] }}</span>
                    </div>
                </ng-container>
            </div>

            <!-- MOBILE -->
            <div class="ranking-info d-flex align-items-center" *ngIf="window.innerWidth < 1200">
                <div class="ranking-info-column">
                    <app-wtn-point
                        [point]="player.wtn.single ? player.wtn.single?.format : player.wtn.double?.format"
                        [tooltip]="player.wtn.single ? player.wtn.single?.title : player.wtn.double?.title"
                    ></app-wtn-point>
                </div>
                <ng-container *ngFor="let column of columns; let index = index">
                    <div [class.ranking-info-column]="column" *ngIf="player.rows[index + 1]">
                        <span>{{ column }}</span>
                        <span>{{ player.rows[index + 1] }}</span>
                    </div>
                </ng-container>
            </div>
        </a>
    </div>
    <app-shared-pagination
        *ngIf="classif?.length"
        [perPage]="perPage"
        [size]="classif.length"
        (onChange)="page = $event"
    ></app-shared-pagination>
</div>
